import { useEffect } from "react";
import { DOCUMENT_TITLE } from "../constants";
import { useUserState } from "../services/backend";

const setTitle = (str?: string, unseen_count?: number) => {
  const start = `${unseen_count ? `(${unseen_count}) ` : ""}${str || ""}`;
  const title = `${start}${str ? " - " : " "}${DOCUMENT_TITLE}`;
  document.title = title;
};

// interface Opts { enabled?: boolean };
/** The default DOCUMENT_TITLE const will be used if no title supplied. */
export const useDocumentTitle = (title?: string) => {
  const { data } = useUserState({
    enabled: false, // leave enabled false in case the hook gets used on an unauthenicated page
    // select: d => d.notification_unseen_count,
  });

  useEffect(() => {
    setTitle(title, data?.notification_unseen_count);
    return () => {
      setTitle("", data?.notification_unseen_count);
    };
  }, [title, data?.notification_unseen_count]);
};
